export default "__VITE_ASSET__1b644884__"